import * as React from 'react';
import theme from '../utils/theme';

export interface HeaderProps {
  title: string;
  subtitle: string;
}

export const Header = (props: HeaderProps) => {
  return (
    <header className={theme.header.panel}>
      <h1 className={theme.header.title}>{props.title}</h1>
      {props.subtitle && (
        <p className={theme.header.subtitle}>{props.subtitle}</p>
      )}
    </header>
  );
};

export default Header;
